//#region src/resources/agent-configuration/ShouldMockAgentConfiguration.ts
var e = "lbergeronsfdevt1z2624x", t = (t, n) => n === !1 ? !1 : n === !0 ? !0 : t === e;
//#endregion
export { t as shouldMockAgentConfiguration };

//# sourceMappingURL=ShouldMockAgentConfiguration.js.map